<template>
  <div class="home-panel">
    <el-alert
      v-if="showProfileWarning"
      class="profile-alert"
      type="warning"
      :closable="false"
      title="Complete your customer profile"
    >
      <template #default>
        <p class="alert-copy">
          Please finish your service preferences and background details before creating a submission.
        </p>
        <div class="alert-actions">
          <el-button type="warning" @click="$emit('complete-profile')">
            Complete profile
          </el-button>
        </div>
      </template>
    </el-alert>

    <el-card class="hero-card" shadow="hover" role="region" aria-label="Create submission">
      <h2>Create a Submission</h2>
      <p>Start a new study protocol request. You'll complete a short, guided form and can optionally attach files to help reviewers.</p>
      <el-button type="primary" size="large" :disabled="createDisabled" @click="$emit('create')">Create Submission</el-button>
      <p v-if="createDisabled" class="disabled-note">
        Finish your customer profile first to unlock submission creation.
      </p>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'HomePanel',
  props: {
    showProfileWarning: { type: Boolean, default: false },
    createDisabled: { type: Boolean, default: false },
  }
}
</script>

<style scoped>
.home-panel {
  display: grid;
  gap: 16px;
}

.profile-alert {
  border-radius: 18px;
  border: 1px solid rgba(180, 95, 6, 0.18);
}

.alert-actions {
  margin-top: 14px;
}

.alert-copy {
  margin: 0;
}

.hero-card {
  text-align: center;
  padding: 28px 22px 30px;
  background:
    radial-gradient(380px 160px at 50% -10%, rgba(0,56,49,.15), transparent 60%),
    linear-gradient(180deg, #ffffff 0%, #f2fbf7 100%);
}

.hero-card h2 {
  margin: 0 0 10px;
  color: var(--primary-strong);
  font-weight: 900;
  font-size: 1.9rem;
  letter-spacing: .2px;
}

.hero-card p {
  margin: 0 0 18px;
  color: var(--ink);
  max-width: 760px;
  margin-left: auto;
  margin-right: auto;
}

.hero-card .el-button {
  font-weight: 800;
  min-width: 200px;
}

.disabled-note {
  margin: 14px 0 0;
  color: #8c5a05;
  font-weight: 600;
}
</style>
